<mm-select-dropdown-control [parentForm]="parentForm" [selectModel]="payIncomeModel">
</mm-select-dropdown-control>